import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { LooksResponse } from './types';

export const fetchLooksActions = createAsyncAction('@LOOKS/FETCH_START', '@LOOKS/FETCH_SUCCESS', '@LOOKS/FETCH_FAILED')<
    FetchAction,
    SuccessFetchActionPayload<LooksResponse>,
    DefaultErrorPayload
>();

export const fetchLooksIfNeeded = (): DataFetchingThunkAction => async (dispatch, getState, { apiService, logger }) => {
    const identifier = 'looks';
    if (identifier === getState().looks.identifier) {
        return;
    }
    dispatch(fetchLooksActions.request({ identifier }));
    try {
        const looks = await apiService.shopApi.getLooks();
        dispatch(fetchLooksActions.success({ data: looks, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchContentLooksIfNeeded');
        dispatch(fetchLooksActions.failure({ error: err, identifier }));
    }
};

export type LooksActionsType = ActionType<typeof fetchLooksActions>;
